var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 349 349",
    width: 50,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "edit-button-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #000000 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m336.8 73.2l-155.4 170.1c-1.4 1.5-3.1 2.7-5 3.6l-52.9 23.1c-2.7 1.2-5.5 1.8-8.4 1.8-6.7 0-13-3.3-16.9-8.7-3.9-5.4-4.9-12.4-2.8-18.7l18.2-54.8c0.7-2 1.8-3.8 3.2-5.4l155.4-170c8.2-9 19.9-14.2 32.1-14.2 10.8 0 21.2 4 29.3 11.4l0.4 0.4c17.7 16.1 18.9 43.7 2.8 61.4zm-175.4 147.5l0.9-1-20.3-18.6-0.9 1-10.7 32.1zm152.3-186.7l-0.4-0.4c-2.5-2.3-5.7-3.5-9.1-3.5-3.8 0-7.3 1.5-9.9 4.4l-132.1 144.6 20.3 18.5 132.1-144.6c5-5.5 4.6-14-0.9-19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m303.9 138.4c-8.3 0-15 6.7-15 15v127.3c0 21.1-17.2 38.2-38.2 38.2h-181.8c-21 0-38.1-17.1-38.1-38.2v-180.3c0-21 17.1-38.1 38.1-38.1h131.6c8.3 0 15-6.7 15-15 0-8.3-6.7-15-15-15h-131.6c-37.6 0-68.1 30.5-68.1 68.1v180.3c0 37.6 30.5 68.2 68.1 68.2h181.8c37.6 0 68.1-30.6 68.1-68.2v-127.3c0.1-8.3-6.7-15-14.9-15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditButton);
export default __webpack_public_path__ + "static/media/edit-button.7b635c65017f371d2d0081e593aed0e6.svg";
export { ForwardRef as ReactComponent };